import { Rest } from 'utilities/rest';
import * as ActionCreator from 'utilities/action.creator';
import { $failure, $requesting, $success } from '../form/action';
import { $processing } from 'services/activity/action';
import { $done } from 'services/activity/action';

export const MODULE = 'Journal';

const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;

export const $reset = ActionCreator.Default(MODULE, 'reset', () =>
  $reset.action()
);

export const $getJournal = ActionCreator.Async(MODULE, 'GetJournal', (payload) => {
  return async (dispatch) => {
    dispatch($processing($getJournal.OPERATION));

    return await Rest.GET(`${API_URL}/accounting/journal`, payload)
      .then((response) => {
        dispatch($getJournal.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($getJournal.OPERATION)));
  };
});

export const $getLedger = ActionCreator.Async(MODULE, 'GetLedger', (payload) => {
  return async (dispatch) => {
    dispatch($processing($getLedger.OPERATION));

    return await Rest.GET(`${API_URL}/accounting/ledger`, payload)
      .then((response) => {
        dispatch($getLedger.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($getLedger.OPERATION)));
  };
});

export const $getBalanceSheet = ActionCreator.Async(MODULE, 'GetBalanceSheet', (payload) => {
  return async (dispatch) => {
    dispatch($processing($getBalanceSheet.OPERATION));

    return await Rest.GET(`${API_URL}/accounting/balance-sheet`, payload)
      .then((response) => {
        dispatch($getBalanceSheet.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($getBalanceSheet.OPERATION)));
  };
});

export const $getProfitAndLoss = ActionCreator.Async(MODULE, 'GetProfitAndLoss', (payload) => {
  return async (dispatch) => {
    dispatch($processing($getProfitAndLoss.OPERATION));

    return await Rest.GET(`${API_URL}/accounting/profit-and-loss`, payload)
      .then((response) => {
        dispatch($getProfitAndLoss.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($getProfitAndLoss.OPERATION)));
  };
});

export const $create = ActionCreator.Async(MODULE, 'Create', (payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.POST(`${API_URL}/accounting/journal`, payload)
      .then((response) => {
        dispatch($create.success({ response: response }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});

export const $show = ActionCreator.Async(MODULE, 'Show', (id) => {
  return async (dispatch) => {
    dispatch($processing($show.OPERATION));

    return await Rest.GET(`${API_URL}/accounting/journal/${id}`)
      .then((response) => {
        dispatch($show.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($show.OPERATION)));
  };
});

export const $update = ActionCreator.Async(MODULE, 'Update', (id, payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.PUT(`${API_URL}/accounting/journal/${id}`, payload)
      .then((response) => {
        dispatch($update.success({ response: response?.data }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});

export const $delete = ActionCreator.Async(MODULE, 'Delete', (id) => {
  return async (dispatch) => {
    dispatch($processing($delete.OPERATION));

    return await Rest.DELETE(`${API_URL}/accounting/journal/${id}`)
      .then((response) => {
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($delete.OPERATION)));
  };
});
